// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.

import React from 'react';
import { Typography } from '@kintent/glide';
import { parseISO } from 'date-fns';

import DateTime from '../../../../components/DateTime';
import { Flex } from '../../../../components/Flex';
import { CERTIFICATION_STATUS } from '../../../../lib/constants';

export function CertificationDate({ selectedCertification, selectedDocument }) {
  const selectedArtifact = selectedDocument ?? selectedCertification;
  if (selectedArtifact?.certificationDate) {
    return (
      <Flex
        gap="16px"
        direction="column"
      >
        <Typography
          as="p"
          level="9"
        >
          {selectedArtifact?.status === CERTIFICATION_STATUS.IN_PROGRESS ? 'Date Expected' : 'Date Achieved'}
        </Typography>
        <Typography
          as="p"
          level="8"
        >
          <DateTime
            date={parseISO(selectedArtifact.certificationDate.substring(0, 10))} /* Date only. */
            shortMonth
            includeYear
          />
        </Typography>
      </Flex>
    );
  }
  return null;
}
